module.exports = __webpack_public_path__ + "img/snow.1a2bbf7d.svg";